import ReactGA from "react-ga4";

export const useGAEvent = () => {
    // Return a function that accepts the event parameters
    return ({category, action, label, value, nonInteraction, transport}) => {
        // Call the ReactGA.event method with the event parameters
        ReactGA.event({
            category,
            action,
            label,
            value,
            nonInteraction,
            transport,
        });
    };
};